import React, {Component} from 'react'
import {Modal, ModalHeader, ModalBody, ModalFooter} from "reactstrap";
import Swal from "sweetalert2";
import Select from "react-select";
import {withTourGuide} from "../../guideComponent/withTourGuide";

class AddInventarisTerm extends Component {
    constructor(props) {
        super(props)
        this.state = {
            prosesSimpan: false,
        }
        this.triggerGuideOnce = this.triggerGuideOnce.bind(this)
    }

    triggerGuideOnce = (e, config) => {
        const { showGuide, isGuideActive, disabledKeys } = this.props;

        const target = e?.currentTarget ?? null;
        if (!target || !config?.key) return;
        if (disabledKeys?.includes(config.key)) return;
        if (isGuideActive) return;
        if (typeof showGuide !== 'function') return;
        showGuide(target, config);
    };

    handleEdit = () => {
        this.setState({ prosesSimpan: true})
        let form = {
            pengajuan_id : this.props.data.pengajuan_inv_id,
            karyawan_id : this.props.data.karyawan_selected.value,
            inventaris_id : this.props.data.inventaris_selected.value,
            tanggal_pengajuan : this.props.data.tanggal_pengajuan,
            pengajuan_desc : this.props.data.pengajuan_desc,
        }
        this.props.request("pengajuan_inventaris/edit", form, 'POST')
            .then((response) => {
                if (response && response.success) {
                    this.props.changeState({
                        modal_edit: false,
                        data: [],
                    }, () => this.props.loadData())
                    Swal.fire({
                        title: 'Berhasil!',
                        text: response.message,
                        icon:'success',
                        confirmButtonText: 'OK'
                    })
                } else if (response) {
                    Swal.fire({
                        title: 'Gagal!',
                        text: response.message,
                        icon: 'error',
                        confirmButtonText: 'OK'
                    })
                }
                this.setState({ prosesSimpan: false})
                this.props.clear()
            })
    }

    render() {
        return (
            <Modal isOpen={this.props.modal_edit} toggle={this.props.clear} style={{ maxWidth: "1000px"}} zIndex={999}>
                <ModalHeader className="modal-header-ipresens" toggle={this.props.clear}>
                    <div className='modal-header-ipresens'>Edit Pengajuan Inventaris</div>
                </ModalHeader>
                <ModalBody className="inventaris-modal-body">
                    <div className="row p-3">
                        <div className="col">
                            <div
                                className="form-group"
                                onPointerEnter={(e) => {
                                    this.triggerGuideOnce(e, {
                                        key: "namaKaryawanEditPengajuanInv",
                                        title: "Nama Karyawan",
                                        content: "Ubah nama karyawan yang terkait dengan pengajuan inventaris ini."
                                    });
                                }}>
                                <label className="pengumuman-label-input" htmlFor="exampleFormControlInput1">
                                    Nama Karyawan
                                </label>
                                <Select
                                    placeholder="Nama karyawan"
                                    backspaceRemoves={true} deleteRemoves={true}
                                    styles={{ paddingLeft: "0px" }}
                                    components={{ DropdownIndicator: () => null, IndicatorSeparator: () => null }}
                                    value={this.props.data.karyawan_selected}
                                    options={this.props.data.karyawan?.map((item) => ({
                                        value: item.karyawan_id,
                                        label: item.karyawan_nama,
                                    })) || []}
                                    onChange={(karyawan_selected) => {
                                        if (!karyawan_selected) {
                                            this.props.changeState({
                                                karyawan_selected: '',
                                            });
                                        } else {
                                            this.props.changeState({
                                                karyawan_selected,
                                            });
                                        }
                                    }}
                                />
                            </div>
                            <div
                                className="form-group"
                                onPointerEnter={(e) => {
                                    this.triggerGuideOnce(e, {
                                        key: "namaInventarisEditPengajuanInv",
                                        title: "Nama Inventaris",
                                        content: "Ubah inventaris yang diajukan oleh karyawan. Ketik untuk mencari inventaris."
                                    });
                                }}>
                                <label className="pengumuman-label-input" htmlFor="exampleFormControlInput1">
                                    Nama Inventaris
                                </label>
                                <Select
                                    placeholder="Nama inventaris"
                                    backspaceRemoves={true} deleteRemoves={true}
                                    styles={{paddingLeft: "0px"}}
                                    components={{DropdownIndicator: () => null, IndicatorSeparator: () => null}}
                                    value={this.props.data.inventaris_selected}
                                    options={this.props.data.inventaris?.map((item) => ({
                                        value: item.inventaris_id,
                                        label: item.inventaris_name,
                                    })) || []}
                                    onChange={(inventaris_selected) => {
                                        if (!inventaris_selected) {
                                            this.props.changeState({
                                                inventaris_selected: '',
                                            });
                                        } else {
                                            this.props.changeState({
                                                inventaris_selected,
                                            });
                                        }
                                    }}
                                />
                            </div>
                            <div className="form-group">
                                <label className="pengumuman-label-input">
                                    Tanggal Pengajuan
                                </label>
                                <input
                                    type="date"
                                    onChange={this.props.handleChange}
                                    className="form-control"
                                    name='tanggal_pengajuan'
                                    value={this.props.data.tanggal_pengajuan}
                                    placeholder="Pilih tanggal"
                                    onPointerEnter={(e) => {
                                        this.triggerGuideOnce(e, {
                                            key: "tanggalEditPengajuanInv",
                                            title: "Tanggal Pengajuan",
                                            content: "Ubah tanggal pengajuan inventaris sesuai kebutuhan."
                                        });
                                    }}
                                />
                            </div>
                            <div className="form-group">
                                <label className="pengumuman-label-input">
                                    Keterangan
                                </label>
                                <textarea
                                    className="form-control"
                                    placeholder="Keterangan"
                                    onChange={this.props.handleChange}
                                    name='pengajuan_desc'
                                    value={this.props.data.pengajuan_desc}
                                    onPointerEnter={(e) => {
                                        this.triggerGuideOnce(e, {
                                            key: "keteranganEditPengajuanInv",
                                            title: "Keterangan",
                                            content: "Ubah keterangan atau alasan pengajuan inventaris oleh karyawan."
                                        });
                                    }}>
                </textarea>
                            </div>
                        </div>
                    </div>
                </ModalBody>
                <ModalFooter className="inventaris-modal-footer">
                    <button onClick={this.props.clear}
                            className='btn text-capitalize batalkan-add-jamker'>Batal</button>
                    <button className='btn btn-primary text-capitalize' disabled={this.state.prosesSimpan}
                            style={{padding: "8px 14px", fontWeight: 500, fontSize: "14px", lineHeight: "24px"}}
                            onClick={this.handleEdit}>{this.state.prosesSimpan ? "Menyimpan" : "Simpan"}
                    </button>
                </ModalFooter>
            </Modal>
        )
    }
}

export default withTourGuide(AddInventarisTerm);
